<template>
    <div class="tz-container">
      <div class="tz-box">
        <div class="tz-banner">
          <b-img fluid :src="competition.thumbnail" />
        </div>
        <div class="tz-box-content">
          <div class="tz-img-container">
              <b-img fluid src="/static/image/icon_home1_30x30.png" class="d-none d-sm-inline tz-icon" />
              <span class="tz-title">{{ competition.name}}</span>
          </div>
          <hr />
          <div class="tz-box-info">
            <div  class="tz-img-container">
                <b-img fluid src="/static/image/icon_home2_30x30.png" class="d-none d-sm-inline tz-icon"  />
                 <span class="info">{{!competition.sponsor?'':competition.sponsor.replace("|","\t")}}</span>               
            </div>
            <div  class="tz-img-container">
                <b-img fluid src="/static/image/supporter_icon.png" class="d-none d-sm-inline tz-icon"  />
                <span class="info">承办方：{{!competition.organizer?'':competition.organizer.replace("|","\t")}}</span>
            </div>
            <div  class="tz-img-container">
                <b-img fluid src="/static/image/supporter_icon.png" class="d-none d-sm-inline tz-icon"  />
                <span class="info">技术支持方：{{ !competition.supporter?'':competition.supporter.replace("|","\t")}}</span>
            </div>
             <div  class="tz-img-container">
                <b-img fluid src="/static/image/supporter_icon.png" class="d-none d-sm-inline tz-icon"  />
                <span class="info">联合支持单位：{{ !competition.supporter2?'':competition.supporter2.replace("|","\t")}}</span>
            </div>
          </div>
        </div>
        <div class="team-info">
              <b-img src="/static/image/medal_icon.png" />
                <div class="tz-flex">
                    <div class="tz-border">
                        <div>{{ competition.teamCount}}</div>
                        <div>参赛团队</div>
                    </div>
                    <div class="tz-v-spliter"></div>
                    <div>
                        <div>{{ competition.peopleCount }}</div>
                        <div>参赛人数</div>
                </div>
              </div>
        </div>
      </div>

      <div v-for="item in competition.stageList" :key="item.id">
        <div class="stage-name">
          <hr class="black-hr" /> <div> <div class="stage-icon"> {{ item.name.substring(0,1)}}</div><span>{{item.name}}</span> </div><hr class="black-hr" />
        </div>

        <div class="stage-list">
          <div v-if="!!getStartTime(item.id,1)" class="stage-box" @click="gotPage(1,item.id)">
            <div class="stage-header">
              <div>投资者教育赛项</div>
              <div >进入答题></div>
            </div>
            <div>
              <b-img fluid src="/static/image/img4_580x260.jpg?v=1.1"/>
            </div>
            <div class="stage-time">
              竞赛时间:<span>{{getStartTime(item.id,1)}}</span>--<span>{{getEndTime(item.id,1)}}</span>
            </div>
          </div>
          <div class="stage-box" @click="gotPage(2,item.id)">
            <div class="stage-header">
              <div>证券投资交易赛项</div>
              <div>进入交易></div>
            </div>
            <div>
              <b-img fluid src="/static/image/img1_580x260.jpg"/>
            </div>
            <div class="stage-time">
              竞赛时间:<span>{{getStartTime(item.id,3)}}</span>--<span>{{getEndTime(item.id,3)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import * as taskApi from '@/api/task'
export default {
  data(){
    return {
      compId: 0,
      taskList: []
    }
  },
  props:{
    competition:{
      type: Object,
      default: function() { return {}}
    }
  },
  created(){   
    if(this.$route.query){
      this.compId = this.$route.query.id
      taskApi.list(this.compId).then(res=>{
        if(res.code == 200){
          this.taskList = res.data.list
        }
      })
    }
  },
  methods:{
    gotPage(type,id){
      if(type ==1){
        let routeData = this.$router.resolve({
          path: '/exam',
          query: { id: this.compId,stageId: id }
        })
        window.open(routeData.href,'_blank')
        // this.$router.push({
        //   path: '/exam',
        //   query: { id: this.compId,stageId: id }
        // })
      }else{
        let routerData = this.$router.resolve({
          path: '/system',
          query: { id: this.compId,stageId: id}
        })
        window.open(routerData.href,'_blank')
        // this.$router.push({
        //   path: '/system',
        //   query: { id: this.compId,stageId: id}
        // })
      }
    },
    getThumbnail(stageId,type){
       let stage = this.getStage(stageId)
       if(stage){
         if(type == 1){
           return stage.examLogo
         }else{
           return stage.operationLogo
         }
       }
       return '/static/image/img1_580x260.jpg';
    },
    getStartTime(stageId,type){
      let stage = this.getStage(stageId)
       if(stage){
         if(type == 1){
           if(stage.examStartTime){
             return new Date(stage.examStartTime).Format('yyyy-MM-dd hh:mm:ss')
           }else{
             return null
           }
           
         }else{
           return new Date(stage.operationStartTime).Format('yyyy-MM-dd hh:mm:ss')
         }
       }
       return null;
    },
    getEndTime(stageId,type){
      let stage = this.getStage(stageId)
       if(stage){
         if(type == 1){
           return new Date(stage.examEndTime).Format('yyyy-MM-dd hh:mm:ss')
         }else{
           return new Date(stage.operationEndTime).Format('yyyy-MM-dd hh:mm:ss')
         }
       }
       return '';
    },
    getStage(stageId){
        let rs = this.taskList.filter(task=> task.stageId == stageId)
        if(!!rs&&rs.length>0){
          return rs[0]
        }
    }
  }
    
}
</script>
<style scoped>
.tz-container{
  margin-top: 1rem;
  max-width: 75rem;
  margin: auto;
  margin-top: 1rem;
  text-align: left;
  
}
.tz-box-content{
  width: 55%;
  padding: .8rem;
}
.tz-box-info>div{
  margin-top: 0.3rem;
}
.tz-box{
  box-shadow: -1px -1px 10px 1px #c4c4c4 ;
  border-radius: 8px;
  display: flex;
}
.tz-box>div{
  
}
.stage-header{
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: white;
  font-weight: bold;
}
.stage-header>div:nth-child(1){
  background-color: #2d6dcc;
  padding: .5rem;
  border-top-left-radius: 10px;
  width: 80%;
}
.stage-time{
  padding: 0.5rem;
  width: 100%;
  text-align: center;
}
.stage-time>span:nth-child(1){
  color: #ff7200;
  margin-left: .5rem;
}
.stage-time>span:nth-child(2){
  color: #ff0000;
  margin-right: .5rem;
}
.stage-header>div:nth-child(2){
  background-color: #ff6600;
  padding: .5rem;
  border-top-right-radius: 10px;
  width: 20%;
  text-align: center;
}
.stage-list{
  display: flex;
  justify-content: center;
}
.stage-box{
  box-shadow: -1px -1px 10px 1px #c4c4c4 ;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 2rem;
}
.stage-list>div{
  width: 36.25rem;
}
.tz-flex{
  display: flex;
  justify-content: center;
}
.team-info{
  background-image: url(/static/image/sx_bg.png);
  background-size: cover;
  width: 23%;
  text-align: center;
  padding: 1rem;
  color: white;
  font-weight: bold;
}
.tz-title{
  font-size: 100%;
  font-weight: bold;
  margin-left: 1rem;
}
.tz-banner{
  margin-right: 1rem;
  padding: .8rem;
  width: 25rem;
}
.info{
  margin-left: 1rem;
}
.tz-img-container{
  display: flex;
  align-items: center;
}
.tz-v-spliter{
   width: 1px;
   height: 2rem;
   border-right: 1px solid #3582dc;
   margin-left: 0.5rem;
   margin-right: 0.5rem;
   margin-top: 0.5rem;
}
.stage-name{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.stage-name>div{
  margin-left: .5rem;
  margin-right: .5rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 120%;
}
.stage-icon{
  background-color: #0263d3;
  color: white;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: .5rem;
}
.black-hr{
  width: 4.5rem;
  border: none;
  background: black;
}
</style>


// WEBPACK FOOTER //
// src/views/competition/first.vue